export const KB = 1024;
export const MB = 1024 * KB;
